import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// ─── SABITLER ────────────────────────────────────────────────
const CURRENCIES = ['TRY', 'USD', 'EUR', 'GBP', 'CHF', 'SAR', 'AED'];

const BANKS = [
  'Ziraat Bankasi', 'Is Bankasi', 'Garanti BBVA', 'Yapi Kredi', 'Akbank',
  'Vakifbank', 'Halkbank', 'Denizbank', 'QNB Finansbank', 'TEB',
  'ING', 'HSBC', 'Sekerbank', 'Odeabank', 'Diğer'
];

const BANK_TX_TYPES = [
  { value: 'deposit',      label: 'Para Yatirma',     sign: 1,  color: '#16a34a' },
  { value: 'transfer_in',  label: 'Gelen Havale/EFT', sign: 1,  color: '#0284c7' },
  { value: 'interest',     label: 'Faiz Geliri',      sign: 1,  color: '#7c3aed' },
  { value: 'withdrawal',   label: 'Para Cekme',       sign: -1, color: '#dc2626' },
  { value: 'transfer_out', label: 'Giden Havale/EFT', sign: -1, color: '#d97706' },
  { value: 'expense',      label: 'Masraf/Gider',     sign: -1, color: '#ef4444' },
  { value: 'bank_fee',     label: 'Banka Masrafi',    sign: -1, color: '#f97316' },
];

const CASH_TX_TYPES = [
  { value: 'income',       label: 'Nakit Tahsilat',   sign: 1,  color: '#16a34a' },
  { value: 'transfer_in',  label: 'Kasa Girişi',      sign: 1,  color: '#0284c7' },
  { value: 'expense',      label: 'Nakit Ödeme',      sign: -1, color: '#dc2626' },
  { value: 'transfer_out', label: 'Kasa Çıkışi',      sign: -1, color: '#d97706' },
];

const EXP_TX_TYPES = [
  { value: 'expense',  label: 'Harcama',      sign: -1, color: '#dc2626' },
  { value: 'payment',  label: 'Kart Ödemesi', sign: 1,  color: '#16a34a' },
  { value: 'refund',   label: 'İade',         sign: 1,  color: '#0284c7' },
];

const EXPENSE_CATS = [
  'Yemek & Icecek', 'Ulasim', 'Konaklama', 'Yakit', 'Kirtasiye',
  'Teknoloji', 'Egitim', 'Saglik', 'Temsil & Agirma', 'Diğer'
];

const CURRENCY_FLAGS = { TRY: '🇹🇷', USD: '🇺🇸', EUR: '🇪🇺', GBP: '🇬🇧', CHF: '🇨🇭', SAR: '🇸🇦', AED: '🇦🇪' };

// ─── YARDIMCI FONKSİYONLAR ────────────────────────────────────
function fmt(n, cur = 'TRY') {
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0) + ' ' + cur;
}
function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('tr-TR');
}
function txInfo(types, type) {
  return types.find(t => t.value === type) || { label: type, sign: 1, color: '#888' };
}

// ─── ORTAK BİLEŞENLER ─────────────────────────────────────────
function Msg({ msg }) {
  if (!msg) return null;
  return (
    <div style={{
      padding: '8px 14px', borderRadius: 'var(--r-md)', marginBottom: 12, fontSize: '0.82rem',
      background: msg.type === 'success' ? 'var(--success-bg)' : 'var(--danger-bg)',
      color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
      border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
    }}>{msg.text}</div>
  );
}

function TxBadge({ types, type }) {
  const info = txInfo(types, type);
  return (
    <span style={{
      background: info.color + '18', color: info.color,
      borderRadius: 99, padding: '2px 8px', fontSize: '0.72rem', fontWeight: 600
    }}>{info.label}</span>
  );
}

function DeleteBtn({ onClick, title = 'Sil' }) {
  return (
    <button onClick={onClick} title={title} style={{
      background: 'none', border: 'none', cursor: 'pointer', color: 'var(--danger)', padding: 3, opacity: 0.6
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
      </svg>
    </button>
  );
}

function TransactionTable({ types, transactions, loading, onDelete, currency }) {
  if (loading) return <div style={{ textAlign: 'center', padding: 20, color: 'var(--text-secondary)', fontSize: '0.82rem' }}>Yükleniyor...</div>;
  if (!transactions.length) return (
    <div style={{ textAlign: 'center', padding: 28, color: 'var(--text-secondary)', fontSize: '0.82rem' }}>
      Henuz islem yok.
    </div>
  );
  return (
    <div style={{ border: '1px solid var(--border-secondary)', borderRadius: 'var(--r-md)', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem', minWidth: 680 }}>
        <thead>
          <tr style={{ background: 'var(--bg-secondary)' }}>
            {['Tarih', 'Açıklama', 'Tür', 'Tutar', 'İşlem Sonrasi', ''].map(h => (
              <th key={h} style={{ padding: '8px 10px', textAlign: 'left', color: 'var(--text-secondary)', fontWeight: 600, borderBottom: '1px solid var(--border-secondary)', whiteSpace: 'nowrap' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx, i) => {
            const info = txInfo(types, tx.transaction_type);
            const isIncome = info.sign > 0;
            return (
              <tr key={tx.id} style={{ borderBottom: i < transactions.length - 1 ? '1px solid var(--border-secondary)' : 'none' }}>
                <td style={{ padding: '7px 10px', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>{fmtDate(tx.transaction_date)}</td>
                <td style={{ padding: '7px 10px', color: 'var(--text-primary)' }}>
                  <div>{tx.description}</div>
                  {tx.counterparty && <div style={{ fontSize: '0.72rem', color: 'var(--text-tertiary)' }}>Karsi taraf: {tx.counterparty}</div>}
                  {tx.expense_category && <div style={{ fontSize: '0.72rem', color: 'var(--text-tertiary)' }}>{tx.expense_category}</div>}
                  {tx.reference_no && <div style={{ fontSize: '0.72rem', color: 'var(--text-tertiary)' }}>Ref: {tx.reference_no}</div>}
                  {tx.source_type && (() => {
                    const srcLabels = { cari_payment: 'Tediye', expense_voucher: 'Gider Fişi', cari_receipt: 'Tahsilat' };
                    const srcNo = tx.source_payment_no || tx.source_voucher_no || tx.source_receipt_no || '';
                    return (
                      <span style={{ display:'inline-block', marginTop: 3, fontSize:'0.66rem', fontWeight: 700, padding:'1px 7px', borderRadius: 100,
                                     background:'rgba(124,58,237,0.10)', color:'#7c3aed',
                                     border:'1px solid rgba(124,58,237,0.25)',
                                     letterSpacing:'0.04em', textTransform:'uppercase' }}>
                        🔗 {srcLabels[tx.source_type] || tx.source_type}{srcNo ? ' ' + srcNo : ''}
                      </span>
                    );
                  })()}
                </td>
                <td style={{ padding: '7px 10px' }}><TxBadge types={types} type={tx.transaction_type} /></td>
                <td style={{ padding: '7px 10px', fontWeight: 700, whiteSpace: 'nowrap', color: isIncome ? 'var(--success)' : 'var(--danger)' }}>
                  {isIncome ? '+' : '-'}{fmt(tx.amount, currency)}
                </td>
                <td style={{ padding: '7px 10px', color: 'var(--text-secondary)', whiteSpace: 'nowrap', fontSize: '0.78rem' }}>
                  {tx.balance_after != null ? fmt(tx.balance_after, currency) : '—'}
                </td>
                <td style={{ padding: '7px 10px', textAlign: 'right' }}>
                  {!tx.source_type && <DeleteBtn onClick={() => onDelete(tx.id)} title="İşlemi Sil (bakiye geri alinir)" />}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ─── ANA SAYFA ────────────────────────────────────────────────
// Sadece Firma Kredi Kartları yönetimi (Banka/Kasa için ayrı modüller var: BankAccountsPage, CashRegistersPage).
export default function FinancePage() {
  return (
    <div style={{ padding: '20px', maxWidth: 1400, margin: '0 auto' }}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 22 }}>💳</span>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>Firma Kredi Kartları</h2>
      </div>
      <ExpenseCardsTab />
    </div>
  );
}

// ══════════════════════════════════════════
// BANKA HESAPLARI TAB
// ══════════════════════════════════════════
function BankAccountsTab() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [txLoading, setTxLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({});
  const [isNew, setIsNew] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showTxForm, setShowTxForm] = useState(false);
  const [txForm, setTxForm] = useState({});
  const [txSaving, setTxSaving] = useState(false);
  const [txMsg, setTxMsg] = useState(null);

  const emptyAccount = { account_name: '', bank_name: '', branch_name: '', account_number: '', iban: '', currency_code: 'TRY', current_balance: 0, notes: '', is_active: true };
  const emptyTx = { transaction_date: new Date().toISOString().substring(0,10), description: '', transaction_type: 'transfer_in', amount: '', reference_no: '', counterparty: '', notes: '' };

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/bank-accounts', { params: { search } });
      if (res.data.success) setAccounts(res.data.data.items);
    } catch {} finally { setLoading(false); }
  }, [search]);

  useEffect(() => { fetch(); }, [fetch]);

  const fetchTx = async (id) => {
    setTxLoading(true);
    try {
      const res = await api.get(`/bank-accounts/${id}/transactions`);
      if (res.data.success) setTransactions(res.data.data);
    } catch {} finally { setTxLoading(false); }
  };

  const openAccount = async (acc) => {
    setSelected(acc); setForm(acc); setIsNew(false); setIsEditing(false); setMsg(null);
    setShowModal(true); setShowTxForm(false);
    fetchTx(acc.id);
  };

  const openNew = () => {
    setSelected(null); setForm({ ...emptyAccount }); setIsNew(true); setIsEditing(true);
    setMsg(null); setTransactions([]); setShowModal(true); setShowTxForm(false);
  };

  const save = async () => {
    if (!form.account_name || !form.bank_name) { setMsg({ type: 'error', text: 'Hesap adi ve banka adi zorunludur' }); return; }
    setSaving(true); setMsg(null);
    try {
      if (isNew) {
        const res = await api.post('/bank-accounts', form);
        if (res.data.success) {
          setIsNew(false); setIsEditing(false); fetch();
          const r2 = await api.get('/bank-accounts/' + res.data.data.id);
          if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
          setMsg({ type: 'success', text: 'Hesap olusturuldu' });
        }
      } else {
        await api.put('/bank-accounts/' + selected.id, form);
        setIsEditing(false); fetch();
        const r2 = await api.get('/bank-accounts/' + selected.id);
        if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
        setMsg({ type: 'success', text: 'Hesap guncellendi' });
      }
    } catch (err) { setMsg({ type: 'error', text: err.response?.data?.message || 'Hata olustu' }); }
    finally { setSaving(false); }
  };

  const del = async () => {
    if (!window.confirm('Bu hesabi silmek istiyor musunuz?')) return;
    try { await api.delete('/bank-accounts/' + selected.id); setShowModal(false); fetch(); }
    catch (err) { setMsg({ type: 'error', text: err.response?.data?.message || 'Silinemedi' }); }
  };

  const saveTx = async () => {
    if (!txForm.description || !txForm.amount || !txForm.transaction_date) { setTxMsg({ type: 'error', text: 'Tarih, aciklama ve tutar zorunludur' }); return; }
    setTxSaving(true); setTxMsg(null);
    try {
      await api.post(`/bank-accounts/${selected.id}/transactions`, txForm);
      setShowTxForm(false);
      await fetchTx(selected.id);
      const r2 = await api.get('/bank-accounts/' + selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { setTxMsg({ type: 'error', text: err.response?.data?.message || 'Hata olustu' }); }
    finally { setTxSaving(false); }
  };

  const deleteTx = async (txId) => {
    if (!window.confirm('Bu islemi silmek istiyor musunuz? Bakiye geri alinacak.')) return;
    try {
      await api.delete(`/bank-accounts/${selected.id}/transactions/${txId}`);
      await fetchTx(selected.id);
      const r2 = await api.get('/bank-accounts/' + selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { alert(err.response?.data?.message || 'Silinemedi'); }
  };

  const totalBalance = accounts.filter(a => a.is_active && a.currency_code === 'TRY').reduce((s, a) => s + (a.current_balance || 0), 0);
  const activeCount = accounts.filter(a => a.is_active).length;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: 16, minHeight: 500 }}>
      {/* SOL: Hesap Listesi */}
      <div style={{ background: 'var(--bg-card)', borderRadius: 'var(--r-lg)', boxShadow: 'var(--shadow-sm)', border: '1px solid var(--border-secondary)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border-secondary)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontWeight: 600, fontSize: '0.88rem', color: 'var(--text-primary)' }}>Hesaplar ({activeCount})</span>
            <button onClick={openNew} style={{
              background: 'var(--accent-primary)', color: '#fff', border: 'none',
              borderRadius: 'var(--r-md)', padding: '4px 10px', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600
            }}>+ Ekle</button>
          </div>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Ara..." style={{
            width: '100%', padding: '6px 10px', border: '1px solid var(--border-input)',
            borderRadius: 'var(--r-md)', background: 'var(--bg-input)', color: 'var(--text-primary)', fontSize: '0.82rem'
          }} />
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {loading ? <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.82rem' }}>Yükleniyor...</div>
            : accounts.length === 0 ? (
              <div style={{ padding: 30, textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.82rem' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🏦</div>
                Hesap eklenmemis
              </div>
            ) : accounts.map(acc => (
              <div key={acc.id} onClick={() => openAccount(acc)} style={{
                padding: '12px 14px', borderBottom: '1px solid var(--border-secondary)', cursor: 'pointer',
                background: selected?.id === acc.id ? 'var(--accent-glow)' : 'none',
                borderLeft: selected?.id === acc.id ? '3px solid var(--accent-primary)' : '3px solid transparent',
                opacity: acc.is_active ? 1 : 0.5,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: '0.85rem', color: 'var(--text-primary)' }}>{acc.account_name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: 2 }}>{acc.bank_name}{acc.branch_name ? ' / ' + acc.branch_name : ''}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontWeight: 700, fontSize: '0.85rem', color: acc.current_balance >= 0 ? 'var(--success)' : 'var(--danger)' }}>
                      {fmt(acc.current_balance, acc.currency_code)}
                    </div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)' }}>{CURRENCY_FLAGS[acc.currency_code]} {acc.currency_code}</div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {accounts.filter(a => a.is_active && a.currency_code === 'TRY').length > 0 && (
          <div style={{ padding: '10px 14px', borderTop: '1px solid var(--border-secondary)', background: 'var(--bg-secondary)' }}>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-tertiary)' }}>TRY Toplam</div>
            <div style={{ fontWeight: 700, color: totalBalance >= 0 ? 'var(--success)' : 'var(--danger)', fontSize: '0.9rem' }}>{fmt(totalBalance)}</div>
          </div>
        )}
      </div>

      {/* SAĞ: Detay / Form */}
      <div style={{ background: 'var(--bg-card)', borderRadius: 'var(--r-lg)', boxShadow: 'var(--shadow-sm)', border: '1px solid var(--border-secondary)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {!showModal ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-tertiary)' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: 10 }}>🏦</div>
              <div>Sol taraftan bir hesap secin veya yeni hesap ekleyin</div>
            </div>
          </div>
        ) : (
          <>
            {/* Başlık */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', borderBottom: '1px solid var(--border-secondary)' }}>
              <h3 style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: '0.95rem' }}>
                {isNew ? 'Yeni Banka Hesabi' : form.account_name}
                {!isNew && !isEditing && <span style={{ marginLeft: 8, fontSize: '0.75rem', color: form.is_active ? 'var(--success)' : 'var(--danger)', background: form.is_active ? 'var(--success-bg)' : 'var(--danger-bg)', padding: '2px 8px', borderRadius: 99, fontWeight: 600 }}>{form.is_active ? 'Aktif' : 'Pasif'}</span>}
              </h3>
              <div style={{ display: 'flex', gap: 8 }}>
                {!isNew && !isEditing && <>
                  <button onClick={() => { setIsEditing(true); setMsg(null); }} style={{ background: 'var(--accent-primary)', color: '#fff', border: 'none', borderRadius: 'var(--r-md)', padding: '5px 12px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600 }}>Duzenle</button>
                  <button onClick={del} style={{ background: 'var(--danger-bg)', color: 'var(--danger)', border: '1px solid var(--danger)', borderRadius: 'var(--r-md)', padding: '5px 12px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600 }}>Sil</button>
                </>}
                <button onClick={() => { setShowModal(false); setSelected(null); setIsEditing(false); setIsNew(false); setMsg(null); setShowTxForm(false); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)', padding: 4 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px' }}>
              <Msg msg={msg} />

              {isEditing ? (
                /* FORM */
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  {[
                    { label: 'Hesap Adi *', f: 'account_name', span: 2 },
                    { label: 'Banka *', f: 'bank_name', type: 'select', opts: BANKS.map(b => ({v:b,l:b})), span: 1 },
                    { label: 'Şube', f: 'branch_name', span: 1 },
                    { label: 'Hesap No', f: 'account_number', span: 1 },
                    { label: 'IBAN', f: 'iban', span: 1 },
                    { label: 'Para Birimi', f: 'currency_code', type: 'select', opts: CURRENCIES.map(c=>({v:c,l:CURRENCY_FLAGS[c]+' '+c})), span: 1 },
                    { label: 'Açılış Bakiyesi', f: 'current_balance', type: 'number', span: 1, show: isNew },
                    { label: 'Notlar', f: 'notes', span: 2 },
                  ].filter(f => f.show !== false).map(f => (
                    <div key={f.f} style={{ gridColumn: f.span === 2 ? 'span 2' : undefined }}>
                      <label style={{ display: 'block', fontSize: '0.77rem', color: 'var(--text-secondary)', marginBottom: 3, fontWeight: 500 }}>{f.label}</label>
                      {f.type === 'select' ? (
                        <select value={form[f.f] || ''} onChange={e => setForm(p=>({...p,[f.f]:e.target.value}))} style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }}>
                          {f.opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type={f.type || 'text'} value={form[f.f] ?? ''} onChange={e => setForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))}
                          style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }} />
                      )}
                    </div>
                  ))}
                  <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <input type="checkbox" id="ba_active" checked={!!form.is_active} onChange={e => setForm(p=>({...p, is_active: e.target.checked}))} />
                    <label htmlFor="ba_active" style={{ fontSize:'0.83rem', color:'var(--text-primary)' }}>Aktif</label>
                  </div>
                  <div style={{ gridColumn: 'span 2', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button onClick={() => { if (isNew) { setShowModal(false); } else { setForm(selected); setIsEditing(false); } setMsg(null); }} style={{ padding:'6px 16px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.83rem' }}>İptal</button>
                    <button onClick={save} disabled={saving} style={{ padding:'6px 16px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.83rem', opacity:saving?.6:1 }}>{saving?'Kaydediliyor...':'Kaydet'}</button>
                  </div>
                </div>
              ) : (
                /* DETAY GÖRÜNÜMÜ */
                <>
                  {/* Bakiye Kutusu */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 18 }}>
                    {[
                      { label: 'Guncel Bakiye', value: fmt(selected?.current_balance, selected?.currency_code), color: selected?.current_balance >= 0 ? 'var(--success)' : 'var(--danger)' },
                      { label: 'Hesap No', value: selected?.account_number || '—', color: 'var(--text-primary)' },
                      { label: 'IBAN', value: selected?.iban || '—', color: 'var(--text-primary)' },
                    ].map((s,i) => (
                      <div key={i} style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-md)', padding:'10px 14px', border:'1px solid var(--border-secondary)' }}>
                        <div style={{ fontSize:'0.7rem', color:'var(--text-tertiary)', marginBottom:3 }}>{s.label}</div>
                        <div style={{ fontWeight:700, fontSize:'0.88rem', color:s.color, wordBreak:'break-all' }}>{s.value}</div>
                      </div>
                    ))}
                  </div>

                  {/* İşlemler başlığı */}
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                    <h4 style={{ fontWeight:600, fontSize:'0.88rem', color:'var(--text-primary)' }}>İşlem Gecmisi</h4>
                    <button onClick={() => { setTxForm({...emptyTx}); setTxMsg(null); setShowTxForm(true); }} style={{
                      background:'var(--success-bg)', color:'var(--success)', border:'1px solid var(--success)',
                      borderRadius:'var(--r-md)', padding:'4px 10px', cursor:'pointer', fontSize:'0.78rem', fontWeight:600
                    }}>+ İşlem Ekle</button>
                  </div>

                  {/* İşlem Formu (inline) */}
                  {showTxForm && (
                    <div style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-lg)', padding:'14px 16px', marginBottom:14, border:'1px solid var(--border-secondary)' }}>
                      <Msg msg={txMsg} />
                      <div style={{ marginBottom:10 }}>
                        <div style={{ fontSize:'0.77rem', color:'var(--text-secondary)', marginBottom:5, fontWeight:500 }}>İşlem Türü</div>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                          {BANK_TX_TYPES.map(t => (
                            <button key={t.value} onClick={() => setTxForm(p=>({...p, transaction_type:t.value}))} style={{
                              padding:'4px 10px', borderRadius:99, cursor:'pointer', fontSize:'0.77rem', fontWeight:600,
                              background: txForm.transaction_type===t.value ? t.color : t.color+'18',
                              color: txForm.transaction_type===t.value ? '#fff' : t.color,
                              border: `1px solid ${t.color}`,
                            }}>{t.label}</button>
                          ))}
                        </div>
                      </div>
                      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:10 }}>
                        {[
                          { label:'Tarih *', f:'transaction_date', type:'date' },
                          { label:'Tutar *', f:'amount', type:'number' },
                          { label:'Referans No', f:'reference_no' },
                          { label:'Karsi Taraf', f:'counterparty', span:2 },
                          { label:'Açıklama *', f:'description', span:3 },
                          { label:'Not', f:'notes', span:3 },
                        ].map(f => (
                          <div key={f.f} style={{ gridColumn: f.span ? `span ${f.span}` : undefined }}>
                            <label style={{ display:'block', fontSize:'0.72rem', color:'var(--text-secondary)', marginBottom:3 }}>{f.label}</label>
                            <input type={f.type||'text'} value={txForm[f.f]??''} onChange={e=>setTxForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))}
                              style={{ width:'100%', padding:'5px 8px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }} />
                          </div>
                        ))}
                      </div>
                      <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                        <button onClick={() => setShowTxForm(false)} style={{ padding:'5px 14px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.82rem' }}>İptal</button>
                        <button onClick={saveTx} disabled={txSaving} style={{ padding:'5px 14px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.82rem' }}>{txSaving?'Kaydediliyor...':'Kaydet'}</button>
                      </div>
                    </div>
                  )}

                  <TransactionTable types={BANK_TX_TYPES} transactions={transactions} loading={txLoading} onDelete={deleteTx} currency={selected?.currency_code} />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════
// KASA TAB
// ══════════════════════════════════════════
function CashTab() {
  const [registers, setRegisters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [txLoading, setTxLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({});
  const [isNew, setIsNew] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showTxForm, setShowTxForm] = useState(false);
  const [txForm, setTxForm] = useState({});
  const [txSaving, setTxSaving] = useState(false);
  const [txMsg, setTxMsg] = useState(null);

  const emptyReg = { register_name: '', currency_code: 'TRY', current_balance: 0, notes: '', is_active: true };
  const emptyTx = { transaction_date: new Date().toISOString().substring(0,10), description: '', transaction_type: 'income', amount: '', reference_no: '', notes: '' };

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/cash-registers', { params: { search } });
      if (res.data.success) setRegisters(res.data.data.items);
    } catch {} finally { setLoading(false); }
  }, [search]);

  useEffect(() => { fetch(); }, [fetch]);

  const fetchTx = async (id) => {
    setTxLoading(true);
    try {
      const res = await api.get(`/cash-registers/${id}/transactions`);
      if (res.data.success) setTransactions(res.data.data);
    } catch {} finally { setTxLoading(false); }
  };

  const openReg = async (reg) => {
    setSelected(reg); setForm(reg); setIsNew(false); setIsEditing(false); setMsg(null);
    setShowModal(true); setShowTxForm(false); fetchTx(reg.id);
  };
  const openNew = () => {
    setSelected(null); setForm({...emptyReg}); setIsNew(true); setIsEditing(true);
    setMsg(null); setTransactions([]); setShowModal(true); setShowTxForm(false);
  };
  const save = async () => {
    if (!form.register_name) { setMsg({ type:'error', text:'Kasa adi zorunludur' }); return; }
    setSaving(true); setMsg(null);
    try {
      if (isNew) {
        const res = await api.post('/cash-registers', form);
        if (res.data.success) {
          setIsNew(false); setIsEditing(false); fetch();
          const r2 = await api.get('/cash-registers/' + res.data.data.id);
          if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
          setMsg({ type:'success', text:'Kasa olusturuldu' });
        }
      } else {
        await api.put('/cash-registers/' + selected.id, form);
        setIsEditing(false); fetch();
        const r2 = await api.get('/cash-registers/' + selected.id);
        if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
        setMsg({ type:'success', text:'Kasa guncellendi' });
      }
    } catch (err) { setMsg({ type:'error', text: err.response?.data?.message || 'Hata' }); }
    finally { setSaving(false); }
  };
  const del = async () => {
    if (!window.confirm('Bu kasayi silmek istiyor musunuz?')) return;
    try { await api.delete('/cash-registers/' + selected.id); setShowModal(false); fetch(); }
    catch (err) { setMsg({ type:'error', text: err.response?.data?.message || 'Silinemedi' }); }
  };
  const saveTx = async () => {
    if (!txForm.description || !txForm.amount) { setTxMsg({ type:'error', text:'Açıklama ve tutar zorunludur' }); return; }
    setTxSaving(true); setTxMsg(null);
    try {
      await api.post(`/cash-registers/${selected.id}/transactions`, txForm);
      setShowTxForm(false);
      await fetchTx(selected.id);
      const r2 = await api.get('/cash-registers/' + selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { setTxMsg({ type:'error', text: err.response?.data?.message || 'Hata' }); }
    finally { setTxSaving(false); }
  };
  const deleteTx = async (txId) => {
    if (!window.confirm('Bu islemi silmek istiyor musunuz?')) return;
    try {
      await api.delete(`/cash-registers/${selected.id}/transactions/${txId}`);
      await fetchTx(selected.id);
      const r2 = await api.get('/cash-registers/' + selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { alert(err.response?.data?.message || 'Silinemedi'); }
  };

  return (
    <div style={{ display:'grid', gridTemplateColumns:'280px 1fr', gap:16, minHeight:500 }}>
      {/* Kasa Listesi */}
      <div style={{ background:'var(--bg-card)', borderRadius:'var(--r-lg)', boxShadow:'var(--shadow-sm)', border:'1px solid var(--border-secondary)', overflow:'hidden', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'12px 14px', borderBottom:'1px solid var(--border-secondary)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
            <span style={{ fontWeight:600, fontSize:'0.88rem', color:'var(--text-primary)' }}>Kasalar ({registers.length})</span>
            <button onClick={openNew} style={{ background:'var(--accent-primary)', color:'#fff', border:'none', borderRadius:'var(--r-md)', padding:'4px 10px', cursor:'pointer', fontSize:'0.78rem', fontWeight:600 }}>+ Ekle</button>
          </div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Ara..." style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }} />
        </div>
        <div style={{ flex:1, overflowY:'auto' }}>
          {loading ? <div style={{ padding:20, textAlign:'center', color:'var(--text-secondary)', fontSize:'0.82rem' }}>Yükleniyor...</div>
            : registers.length === 0 ? (
              <div style={{ padding:30, textAlign:'center', color:'var(--text-secondary)', fontSize:'0.82rem' }}>
                <div style={{ fontSize:32, marginBottom:8 }}>💵</div>Kasa eklenmemis
              </div>
            ) : registers.map(reg => (
              <div key={reg.id} onClick={()=>openReg(reg)} style={{
                padding:'12px 14px', borderBottom:'1px solid var(--border-secondary)', cursor:'pointer',
                background: selected?.id===reg.id ? 'var(--accent-glow)' : 'none',
                borderLeft: selected?.id===reg.id ? '3px solid var(--accent-primary)' : '3px solid transparent',
                opacity: reg.is_active ? 1 : 0.5,
              }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <div style={{ fontWeight:600, fontSize:'0.85rem', color:'var(--text-primary)' }}>{reg.register_name}</div>
                    <div style={{ fontSize:'0.72rem', color:'var(--text-tertiary)', marginTop:2 }}>{CURRENCY_FLAGS[reg.currency_code]} {reg.currency_code} Kasasi</div>
                  </div>
                  <div style={{ fontWeight:700, fontSize:'0.85rem', color: reg.current_balance >= 0 ? 'var(--success)' : 'var(--danger)' }}>
                    {fmt(reg.current_balance, reg.currency_code)}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Sağ Panel */}
      <div style={{ background:'var(--bg-card)', borderRadius:'var(--r-lg)', boxShadow:'var(--shadow-sm)', border:'1px solid var(--border-secondary)', overflow:'hidden', display:'flex', flexDirection:'column' }}>
        {!showModal ? (
          <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-tertiary)' }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:10 }}>💵</div>
              <div>Sol taraftan bir kasa secin veya yeni kasa ekleyin</div>
            </div>
          </div>
        ) : (
          <>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 18px', borderBottom:'1px solid var(--border-secondary)' }}>
              <h3 style={{ fontWeight:600, color:'var(--text-primary)', fontSize:'0.95rem' }}>
                {isNew ? 'Yeni Kasa' : form.register_name}
                {!isNew && !isEditing && <span style={{ marginLeft:8, fontSize:'0.72rem', color:form.is_active?'var(--success)':'var(--danger)', background:form.is_active?'var(--success-bg)':'var(--danger-bg)', padding:'2px 8px', borderRadius:99, fontWeight:600 }}>{form.is_active?'Aktif':'Pasif'}</span>}
              </h3>
              <div style={{ display:'flex', gap:8 }}>
                {!isNew && !isEditing && <>
                  <button onClick={() => { setIsEditing(true); setMsg(null); }} style={{ background:'var(--accent-primary)', color:'#fff', border:'none', borderRadius:'var(--r-md)', padding:'5px 12px', cursor:'pointer', fontSize:'0.8rem', fontWeight:600 }}>Duzenle</button>
                  <button onClick={del} style={{ background:'var(--danger-bg)', color:'var(--danger)', border:'1px solid var(--danger)', borderRadius:'var(--r-md)', padding:'5px 12px', cursor:'pointer', fontSize:'0.8rem', fontWeight:600 }}>Sil</button>
                </>}
                <button onClick={() => { setShowModal(false); setSelected(null); setIsEditing(false); setIsNew(false); setMsg(null); setShowTxForm(false); }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-secondary)', padding:4 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </div>
            <div style={{ flex:1, overflowY:'auto', padding:'16px 18px' }}>
              <Msg msg={msg} />
              {isEditing ? (
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  {[
                    { label:'Kasa Adi *', f:'register_name', span:2 },
                    { label:'Para Birimi', f:'currency_code', type:'select', opts:CURRENCIES.map(c=>({v:c,l:CURRENCY_FLAGS[c]+' '+c})), span:1 },
                    { label:'Açılış Bakiyesi', f:'current_balance', type:'number', span:1, show: isNew },
                    { label:'Notlar', f:'notes', span:2 },
                  ].filter(f=>f.show!==false).map(f=>(
                    <div key={f.f} style={{ gridColumn:f.span===2?'span 2':undefined }}>
                      <label style={{ display:'block', fontSize:'0.77rem', color:'var(--text-secondary)', marginBottom:3, fontWeight:500 }}>{f.label}</label>
                      {f.type==='select' ? (
                        <select value={form[f.f]||''} onChange={e=>setForm(p=>({...p,[f.f]:e.target.value}))} style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }}>
                          {f.opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type={f.type||'text'} value={form[f.f]??''} onChange={e=>setForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))} style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }} />
                      )}
                    </div>
                  ))}
                  <div style={{ gridColumn:'span 2', display:'flex', alignItems:'center', gap:8 }}>
                    <input type="checkbox" id="cr_active" checked={!!form.is_active} onChange={e=>setForm(p=>({...p,is_active:e.target.checked}))} />
                    <label htmlFor="cr_active" style={{ fontSize:'0.83rem', color:'var(--text-primary)' }}>Aktif</label>
                  </div>
                  <div style={{ gridColumn:'span 2', display:'flex', gap:8, justifyContent:'flex-end' }}>
                    <button onClick={() => { if(isNew){setShowModal(false);}else{setForm(selected);setIsEditing(false);}setMsg(null); }} style={{ padding:'6px 16px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.83rem' }}>İptal</button>
                    <button onClick={save} disabled={saving} style={{ padding:'6px 16px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.83rem', opacity:saving?.6:1 }}>{saving?'Kaydediliyor...':'Kaydet'}</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:18 }}>
                    {[
                      { label:'Guncel Bakiye', value:fmt(selected?.current_balance, selected?.currency_code), color:selected?.current_balance>=0?'var(--success)':'var(--danger)', large:true },
                      { label:'Para Birimi', value:`${CURRENCY_FLAGS[selected?.currency_code]} ${selected?.currency_code}`, color:'var(--text-primary)' },
                    ].map((s,i)=>(
                      <div key={i} style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-md)', padding:'10px 14px', border:'1px solid var(--border-secondary)' }}>
                        <div style={{ fontSize:'0.7rem', color:'var(--text-tertiary)', marginBottom:3 }}>{s.label}</div>
                        <div style={{ fontWeight:700, fontSize:s.large?'1.1rem':'0.88rem', color:s.color }}>{s.value}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                    <h4 style={{ fontWeight:600, fontSize:'0.88rem', color:'var(--text-primary)' }}>İşlem Gecmisi</h4>
                    <button onClick={() => { setTxForm({...emptyTx}); setTxMsg(null); setShowTxForm(true); }} style={{ background:'var(--success-bg)', color:'var(--success)', border:'1px solid var(--success)', borderRadius:'var(--r-md)', padding:'4px 10px', cursor:'pointer', fontSize:'0.78rem', fontWeight:600 }}>+ İşlem Ekle</button>
                  </div>
                  {showTxForm && (
                    <div style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-lg)', padding:'14px 16px', marginBottom:14, border:'1px solid var(--border-secondary)' }}>
                      <Msg msg={txMsg} />
                      <div style={{ marginBottom:10 }}>
                        <div style={{ fontSize:'0.77rem', color:'var(--text-secondary)', marginBottom:5, fontWeight:500 }}>İşlem Türü</div>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                          {CASH_TX_TYPES.map(t=>(
                            <button key={t.value} onClick={()=>setTxForm(p=>({...p,transaction_type:t.value}))} style={{ padding:'4px 10px', borderRadius:99, cursor:'pointer', fontSize:'0.77rem', fontWeight:600, background:txForm.transaction_type===t.value?t.color:t.color+'18', color:txForm.transaction_type===t.value?'#fff':t.color, border:`1px solid ${t.color}` }}>{t.label}</button>
                          ))}
                        </div>
                      </div>
                      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:10 }}>
                        {[
                          { label:'Tarih *', f:'transaction_date', type:'date' },
                          { label:'Tutar *', f:'amount', type:'number' },
                          { label:'Referans No', f:'reference_no' },
                          { label:'Açıklama *', f:'description', span:3 },
                          { label:'Not', f:'notes', span:3 },
                        ].map(f=>(
                          <div key={f.f} style={{ gridColumn:f.span?`span ${f.span}`:undefined }}>
                            <label style={{ display:'block', fontSize:'0.72rem', color:'var(--text-secondary)', marginBottom:3 }}>{f.label}</label>
                            <input type={f.type||'text'} value={txForm[f.f]??''} onChange={e=>setTxForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))} style={{ width:'100%', padding:'5px 8px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }} />
                          </div>
                        ))}
                      </div>
                      <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                        <button onClick={()=>setShowTxForm(false)} style={{ padding:'5px 14px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.82rem' }}>İptal</button>
                        <button onClick={saveTx} disabled={txSaving} style={{ padding:'5px 14px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.82rem' }}>{txSaving?'Kaydediliyor...':'Kaydet'}</button>
                      </div>
                    </div>
                  )}
                  <TransactionTable types={CASH_TX_TYPES} transactions={transactions} loading={txLoading} onDelete={deleteTx} currency={selected?.currency_code} />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════
// MASRAF KARTLARI TAB
// ══════════════════════════════════════════
function ExpenseCardsTab() {
  const [cards, setCards] = useState([]);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [txLoading, setTxLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({});
  const [isNew, setIsNew] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showTxForm, setShowTxForm] = useState(false);
  const [txForm, setTxForm] = useState({});
  const [txSaving, setTxSaving] = useState(false);
  const [txMsg, setTxMsg] = useState(null);
  const [activeTab, setActiveTab] = useState('movements'); // 'movements' | 'statement'
  const [statement, setStatement] = useState(null);
  const [statementLoading, setStatementLoading] = useState(false);
  const [statementPeriod, setStatementPeriod] = useState(() => {
    const d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0');
  });

  const emptyCard = { card_name:'', card_holder:'', bank_name:'', last_four:'', currency_code:'TRY', credit_limit:0, current_balance:0, expiry_month:'', expiry_year:'', statement_day:'', due_day:'', bank_account_id:'', monthly_fee:'', notes:'', is_active:true };
  const emptyTx = { transaction_date:new Date().toISOString().substring(0,10), description:'', transaction_type:'expense', expense_category:'', amount:'', reference_no:'', notes:'' };

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/expense-cards', { params: { search } });
      if (res.data.success) setCards(res.data.data.items);
    } catch {} finally { setLoading(false); }
  }, [search]);

  useEffect(() => { fetch(); }, [fetch]);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/bank-accounts');
        if (r.data.success) setBankAccountsList((r.data.data.items || []).filter(b => b.is_active));
      } catch {}
    })();
  }, []);

  const fetchStatement = useCallback(async (cardId, period) => {
    setStatementLoading(true);
    try {
      const r = await api.get(`/expense-cards/${cardId}/statement`, { params: { period } });
      if (r.data.success) setStatement(r.data.data);
      else setStatement(null);
    } catch (e) {
      setStatement(null);
      alert(e.response?.data?.message || 'Ekstre yüklenemedi');
    } finally { setStatementLoading(false); }
  }, []);

  const fetchTx = async (id) => {
    setTxLoading(true);
    try {
      const res = await api.get(`/expense-cards/${id}/transactions`);
      if (res.data.success) setTransactions(res.data.data);
    } catch {} finally { setTxLoading(false); }
  };

  const openCard = async (card) => {
    setSelected(card); setForm(card); setIsNew(false); setIsEditing(false); setMsg(null);
    setShowModal(true); setShowTxForm(false); fetchTx(card.id);
  };
  const openNew = () => {
    setSelected(null); setForm({...emptyCard}); setIsNew(true); setIsEditing(true);
    setMsg(null); setTransactions([]); setShowModal(true); setShowTxForm(false);
  };
  const save = async () => {
    if (!form.card_name) { setMsg({ type:'error', text:'Kart adi zorunludur' }); return; }
    setSaving(true); setMsg(null);
    try {
      if (isNew) {
        const res = await api.post('/expense-cards', form);
        if (res.data.success) {
          setIsNew(false); setIsEditing(false); fetch();
          const r2 = await api.get('/expense-cards/'+res.data.data.id);
          if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
          setMsg({ type:'success', text:'Kart olusturuldu' });
        }
      } else {
        await api.put('/expense-cards/'+selected.id, form);
        setIsEditing(false); fetch();
        const r2 = await api.get('/expense-cards/'+selected.id);
        if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
        setMsg({ type:'success', text:'Kart guncellendi' });
      }
    } catch (err) { setMsg({ type:'error', text:err.response?.data?.message||'Hata' }); }
    finally { setSaving(false); }
  };
  const del = async () => {
    if (!window.confirm('Bu karti silmek istiyor musunuz?')) return;
    try { await api.delete('/expense-cards/'+selected.id); setShowModal(false); fetch(); }
    catch (err) { setMsg({ type:'error', text:err.response?.data?.message||'Silinemedi' }); }
  };
  const saveTx = async () => {
    if (!txForm.description || !txForm.amount) { setTxMsg({ type:'error', text:'Açıklama ve tutar zorunludur' }); return; }
    setTxSaving(true); setTxMsg(null);
    try {
      await api.post(`/expense-cards/${selected.id}/transactions`, txForm);
      setShowTxForm(false);
      await fetchTx(selected.id);
      const r2 = await api.get('/expense-cards/'+selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { setTxMsg({ type:'error', text:err.response?.data?.message||'Hata' }); }
    finally { setTxSaving(false); }
  };
  const deleteTx = async (txId) => {
    if (!window.confirm('Bu islemi silmek istiyor musunuz?')) return;
    try {
      await api.delete(`/expense-cards/${selected.id}/transactions/${txId}`);
      await fetchTx(selected.id);
      const r2 = await api.get('/expense-cards/'+selected.id);
      if (r2.data.success) { setSelected(r2.data.data); setForm(r2.data.data); }
      fetch();
    } catch (err) { alert(err.response?.data?.message||'Silinemedi'); }
  };

  // Borcu işaretten bağımsız mutlak değerle hesapla (eski/yeni veri tutarsızlığına dayanıklı)
  const cardDebt = (card) => Math.abs(parseFloat(card?.current_balance) || 0);
  const usedPct = (card) => {
    const lim = parseFloat(card?.credit_limit) || 0;
    return lim > 0 ? Math.min(100, (cardDebt(card) / lim) * 100) : 0;
  };

  return (
    <div className={'finance-cards-layout' + (showModal ? ' has-detail' : '')}>
      {/* Kart Listesi */}
      <div className="finance-cards-list">
        <div style={{ padding:'12px 14px', borderBottom:'1px solid var(--border-secondary)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
            <span style={{ fontWeight:600, fontSize:'0.88rem', color:'var(--text-primary)' }}>Kartlar ({cards.length})</span>
            <button onClick={openNew} style={{ background:'var(--accent-primary)', color:'#fff', border:'none', borderRadius:'var(--r-md)', padding:'4px 10px', cursor:'pointer', fontSize:'0.78rem', fontWeight:600 }}>+ Ekle</button>
          </div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Ara..." style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }} />
        </div>
        <div style={{ flex:1, overflowY:'auto' }}>
          {loading ? <div style={{ padding:20, textAlign:'center', color:'var(--text-secondary)', fontSize:'0.82rem' }}>Yükleniyor...</div>
            : cards.length === 0 ? (
              <div style={{ padding:30, textAlign:'center', color:'var(--text-secondary)', fontSize:'0.82rem' }}>
                <div style={{ fontSize:32, marginBottom:8 }}>💳</div>Kart eklenmemis
              </div>
            ) : cards.map(card => {
              const pct = usedPct(card);
              return (
                <div key={card.id} onClick={()=>openCard(card)} style={{
                  padding:'12px 14px', borderBottom:'1px solid var(--border-secondary)', cursor:'pointer',
                  background: selected?.id===card.id ? 'var(--accent-glow)' : 'none',
                  borderLeft: selected?.id===card.id ? '3px solid var(--accent-primary)' : '3px solid transparent',
                  opacity: card.is_active ? 1 : 0.5,
                }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:'0.85rem', color:'var(--text-primary)' }}>{card.card_name}</div>
                      <div style={{ fontSize:'0.72rem', color:'var(--text-secondary)', marginTop:2 }}>
                        {card.bank_name || '—'} {card.last_four ? `•••• ${card.last_four}` : ''}
                      </div>
                    </div>
                    <div style={{ textAlign:'right', fontSize:'0.8rem', fontWeight:700, color: cardDebt(card) > 0 ? 'var(--warning)' : 'var(--success)' }}>
                      {cardDebt(card) > 0 ? 'Borç: ' + fmt(cardDebt(card), card.currency_code) : fmt(0, card.currency_code)}
                    </div>
                  </div>
                  {card.credit_limit > 0 && (
                    <div style={{ background:'var(--bg-tertiary)', borderRadius:99, height:4, overflow:'hidden' }}>
                      <div style={{ width:pct+'%', height:'100%', background:pct>80?'var(--danger)':pct>60?'var(--warning)':'var(--success)' }} />
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>

      {/* Sağ Panel */}
      <div className="finance-cards-detail">
        {!showModal ? (
          <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-tertiary)' }}>
            <div style={{ textAlign:'center', padding: 20 }}>
              <div style={{ fontSize:40, marginBottom:10 }}>💳</div>
              <div>Sol taraftan bir kart seçin veya yeni kart ekleyin</div>
            </div>
          </div>
        ) : (
          <>
            <div className="finance-cards-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 18px', borderBottom:'1px solid var(--border-secondary)' }}>
              <h3 style={{ fontWeight:600, color:'var(--text-primary)', fontSize:'0.95rem', minWidth: 0, overflow:'hidden', textOverflow:'ellipsis' }}>
                {isNew ? 'Yeni Masraf Kartı' : form.card_name}
                {!isNew && !isEditing && <span style={{ marginLeft:8, fontSize:'0.72rem', color:form.is_active?'var(--success)':'var(--danger)', background:form.is_active?'var(--success-bg)':'var(--danger-bg)', padding:'2px 8px', borderRadius:99, fontWeight:600 }}>{form.is_active?'Aktif':'Pasif'}</span>}
              </h3>
              <div style={{ display:'flex', gap:8, flexShrink: 0 }}>
                {!isNew && !isEditing && <>
                  <button onClick={()=>{setIsEditing(true);setMsg(null);}} style={{ background:'var(--accent-primary)', color:'#fff', border:'none', borderRadius:'var(--r-md)', padding:'5px 12px', cursor:'pointer', fontSize:'0.8rem', fontWeight:600 }}>Duzenle</button>
                  <button onClick={del} style={{ background:'var(--danger-bg)', color:'var(--danger)', border:'1px solid var(--danger)', borderRadius:'var(--r-md)', padding:'5px 12px', cursor:'pointer', fontSize:'0.8rem', fontWeight:600 }}>Sil</button>
                </>}
                <button onClick={()=>{setShowModal(false);setSelected(null);setIsEditing(false);setIsNew(false);setMsg(null);setShowTxForm(false);}} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-secondary)', padding:4 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </div>
            <div style={{ flex:1, overflowY:'auto', padding:'16px 18px' }}>
              <Msg msg={msg} />
              {isEditing ? (
                <div className="finance-cards-form-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  {[
                    { label:'Kart Adı *', f:'card_name', span:2 },
                    { label:'Kart Sahibi', f:'card_holder', span:1 },
                    { label:'Banka', f:'bank_name', type:'select', opts:BANKS.map(b=>({v:b,l:b})), span:1 },
                    { label:'Son 4 Hane', f:'last_four', span:1 },
                    { label:'Para Birimi', f:'currency_code', type:'select', opts:CURRENCIES.map(c=>({v:c,l:CURRENCY_FLAGS[c]+' '+c})), span:1 },
                    { label:'Limit', f:'credit_limit', type:'number', span:1 },
                    { label:'Mevcut Borç', f:'current_balance', type:'number', span:1, show:isNew, hint:'Açılış borç tutarı (pozitif)' },
                    { label:'Son Kullanma Ay', f:'expiry_month', type:'number', span:1 },
                    { label:'Son Kullanma Yil', f:'expiry_year', type:'number', span:1 },
                    { label:'Hesap Kesim Günü (1-31)', f:'statement_day', type:'number', span:1, hint:'Ayın kaçında ekstre kesilir' },
                    { label:'Son Ödeme Günü (1-31)', f:'due_day', type:'number', span:1, hint:'Ayın kaçında son ödeme tarihi' },
                    { label:'Ödeme Yapılacak Banka Hesabı', f:'bank_account_id', type:'select',
                      opts:[{v:'',l:'— yok / seçilmedi —'}, ...bankAccountsList.map(b=>({v:b.id, l:`${b.bank_name||''} ${b.account_name||''} (${b.currency_code||'TRY'})`.trim()}))],
                      span:2, hint:'Kart borcu bu hesaptan ödenecek (manuel kart ödemesinde default seçilir)' },
                    { label:'Aylık Aidat / Üyelik Ücreti', f:'monthly_fee', type:'number', span:2, hint:'Ekstre toplamına eklenir' },
                    { label:'Notlar', f:'notes', span:2 },
                  ].filter(f=>f.show!==false).map(f=>(
                    <div key={f.f} style={{ gridColumn:f.span===2?'span 2':undefined }}>
                      <label style={{ display:'block', fontSize:'0.77rem', color:'var(--text-secondary)', marginBottom:3, fontWeight:500 }}>{f.label}</label>
                      {f.type==='select' ? (
                        <select value={form[f.f]||''} onChange={e=>setForm(p=>({...p,[f.f]:e.target.value}))} style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }}>
                          {f.opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type={f.type||'text'} value={form[f.f]??''} onChange={e=>setForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))} style={{ width:'100%', padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.83rem' }} />
                      )}
                      {f.hint && <div style={{ fontSize:'0.7rem', color:'var(--text-tertiary)', marginTop:3, fontStyle:'italic' }}>{f.hint}</div>}
                    </div>
                  ))}
                  <div style={{ gridColumn:'span 2', display:'flex', alignItems:'center', gap:8 }}>
                    <input type="checkbox" id="ec_active" checked={!!form.is_active} onChange={e=>setForm(p=>({...p,is_active:e.target.checked}))} />
                    <label htmlFor="ec_active" style={{ fontSize:'0.83rem', color:'var(--text-primary)' }}>Aktif</label>
                  </div>
                  <div style={{ gridColumn:'span 2', display:'flex', gap:8, justifyContent:'flex-end' }}>
                    <button onClick={()=>{if(isNew){setShowModal(false);}else{setForm(selected);setIsEditing(false);}setMsg(null);}} style={{ padding:'6px 16px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.83rem' }}>İptal</button>
                    <button onClick={save} disabled={saving} style={{ padding:'6px 16px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.83rem', opacity:saving?.6:1 }}>{saving?'Kaydediliyor...':'Kaydet'}</button>
                  </div>
                </div>
              ) : (
                <>
                  {(() => {
                    // Bakiye işareti tutarsız olabiliyor (eski kayıtlar pozitif borç, yeni kayıtlar negatif borç gibi).
                    // Borcu mutlak değerle al — kullanılabilir = max(0, limit - borç).
                    const debt = Math.abs(parseFloat(selected?.current_balance) || 0);
                    const lim  = parseFloat(selected?.credit_limit) || 0;
                    const avail = Math.max(0, lim - debt);
                    return (
                  <div className="finance-cards-kpi-row" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:18 }}>
                    {[
                      { label:'Mevcut Borç', value: debt > 0 ? fmt(debt, selected?.currency_code) : '—', color:'var(--warning)' },
                      { label:'Kart Limiti', value: lim > 0 ? fmt(lim, selected?.currency_code) : '—', color:'var(--text-primary)' },
                      { label:'Kullanılabilir', value: lim > 0 ? fmt(avail, selected?.currency_code) : '—', color:'var(--success)' },
                    ].map((s,i)=>(
                      <div key={i} style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-md)', padding:'10px 14px', border:'1px solid var(--border-secondary)' }}>
                        <div style={{ fontSize:'0.7rem', color:'var(--text-tertiary)', marginBottom:3 }}>{s.label}</div>
                        <div style={{ fontWeight:700, fontSize:'0.9rem', color:s.color }}>{s.value}</div>
                      </div>
                    ))}
                  </div>
                    );
                  })()}
                  {selected?.credit_limit > 0 && (() => {
                    const debt = Math.abs(parseFloat(selected?.current_balance) || 0);
                    const lim  = parseFloat(selected?.credit_limit) || 0;
                    const pct  = lim > 0 ? Math.min(100, (debt / lim) * 100) : 0;
                    return (
                    <div style={{ marginBottom:18 }}>
                      <div style={{ display:'flex', justifyContent:'space-between', fontSize:'0.75rem', color:'var(--text-secondary)', marginBottom:5 }}>
                        <span>Kullanılan: {fmt(debt, selected.currency_code)}</span>
                        <span>%{pct.toFixed(0)} kullanıldı</span>
                      </div>
                      <div style={{ background:'var(--bg-tertiary)', borderRadius:99, height:8, overflow:'hidden' }}>
                        <div style={{ width:pct+'%', height:'100%', background:pct>80?'var(--danger)':pct>60?'var(--warning)':'var(--success)', transition:'width 0.3s' }} />
                      </div>
                    </div>
                    );
                  })()}
                  {/* Sekme: Hareketler / Ekstre */}
                  <div style={{ display:'flex', gap:4, marginBottom:12, borderBottom:'1px solid var(--border-secondary)' }}>
                    <button onClick={() => setActiveTab('movements')} style={{
                      padding:'8px 16px', border:'none', background:'none', cursor:'pointer',
                      fontWeight: activeTab==='movements' ? 600 : 400, fontSize:'0.85rem',
                      color: activeTab==='movements' ? 'var(--accent-primary)' : 'var(--text-secondary)',
                      borderBottom: activeTab==='movements' ? '2px solid var(--accent-primary)' : '2px solid transparent',
                      marginBottom:-1,
                    }}>Hareketler</button>
                    <button onClick={() => {
                      setActiveTab('statement');
                      if (selected?.id && selected?.statement_day) fetchStatement(selected.id, statementPeriod);
                    }} style={{
                      padding:'8px 16px', border:'none', background:'none', cursor:'pointer',
                      fontWeight: activeTab==='statement' ? 600 : 400, fontSize:'0.85rem',
                      color: activeTab==='statement' ? 'var(--accent-primary)' : 'var(--text-secondary)',
                      borderBottom: activeTab==='statement' ? '2px solid var(--accent-primary)' : '2px solid transparent',
                      marginBottom:-1,
                    }}>Ekstre</button>
                  </div>

                  {activeTab === 'statement' ? (
                    <StatementView
                      selected={selected}
                      statement={statement}
                      loading={statementLoading}
                      period={statementPeriod}
                      onChangePeriod={(p) => { setStatementPeriod(p); fetchStatement(selected.id, p); }}
                    />
                  ) : (
                  <>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                    <h4 style={{ fontWeight:600, fontSize:'0.88rem', color:'var(--text-primary)' }}>Hareketler</h4>
                    <button onClick={()=>{setTxForm({...emptyTx});setTxMsg(null);setShowTxForm(true);}} style={{ background:'var(--success-bg)', color:'var(--success)', border:'1px solid var(--success)', borderRadius:'var(--r-md)', padding:'4px 10px', cursor:'pointer', fontSize:'0.78rem', fontWeight:600 }}>+ İşlem Ekle</button>
                  </div>
                  {showTxForm && (
                    <div style={{ background:'var(--bg-secondary)', borderRadius:'var(--r-lg)', padding:'14px 16px', marginBottom:14, border:'1px solid var(--border-secondary)' }}>
                      <Msg msg={txMsg} />
                      <div style={{ marginBottom:10 }}>
                        <div style={{ fontSize:'0.77rem', color:'var(--text-secondary)', marginBottom:5, fontWeight:500 }}>İşlem Türü</div>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
                          {EXP_TX_TYPES.map(t=>(
                            <button key={t.value} onClick={()=>setTxForm(p=>({...p,transaction_type:t.value}))} style={{ padding:'4px 10px', borderRadius:99, cursor:'pointer', fontSize:'0.77rem', fontWeight:600, background:txForm.transaction_type===t.value?t.color:t.color+'18', color:txForm.transaction_type===t.value?'#fff':t.color, border:`1px solid ${t.color}` }}>{t.label}</button>
                          ))}
                        </div>
                      </div>
                      <div className="finance-tx-form-grid">
                        {(() => {
                          const tt = txForm.transaction_type;
                          const baseFields = [
                            { label:'Tarih *', f:'transaction_date', type:'date' },
                            { label:'Tutar *', f:'amount', type:'number' },
                            { label:'Referans No', f:'reference_no' },
                          ];
                          // Tipe göre dinamik alanlar
                          let conditional = [];
                          if (tt === 'expense') {
                            conditional = [
                              { label:'Masraf Kategorisi', f:'expense_category', type:'select', opts:EXPENSE_CATS.map(c=>({v:c,l:c})), span:3 },
                            ];
                          } else if (tt === 'payment') {
                            conditional = [
                              { label:'Ödeme Yapılacak Banka *', f:'source_bank_account_id', type:'select',
                                opts: bankAccountsList.filter(b => b.is_active !== false).map(b => ({ v: b.id, l: `${b.account_name} — ${b.bank_name} (${b.currency_code})` })),
                                span:3 },
                            ];
                          } else if (tt === 'refund') {
                            const prevExpenses = transactions
                              .filter(t => t.transaction_type === 'expense')
                              .map(t => ({ v: t.id, l: `${fmtDate(t.transaction_date)} · ${(t.description||'').slice(0,40)} · ${fmt(t.amount, selected?.currency_code)}` }));
                            conditional = [
                              { label:'Hangi Harcamanın İadesi (opsiyonel)', f:'linked_expense_tx_id', type:'select',
                                opts: prevExpenses, placeholder:'— Seçim yok —', span:3 },
                            ];
                          }
                          const tailFields = [
                            { label:'Açıklama *', f:'description', span:3 },
                            { label:'Not', f:'notes', span:3 },
                          ];
                          return [...baseFields, ...conditional, ...tailFields].map(f => (
                            <div key={f.f} data-span={f.span} style={{ gridColumn:f.span?`span ${f.span}`:undefined }}>
                              <label style={{ display:'block', fontSize:'0.72rem', color:'var(--text-secondary)', marginBottom:3 }}>{f.label}</label>
                              {f.type==='select' ? (
                                <select value={txForm[f.f]||''} onChange={e=>setTxForm(p=>({...p,[f.f]:e.target.value}))}
                                        style={{ width:'100%', padding:'5px 8px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }}>
                                  <option value=''>{f.placeholder || 'Seçiniz'}</option>
                                  {f.opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                                </select>
                              ) : (
                                <input type={f.type||'text'} value={txForm[f.f]??''} onChange={e=>setTxForm(p=>({...p,[f.f]:f.type==='number'?(e.target.value===''?'':parseFloat(e.target.value)):e.target.value}))}
                                       style={{ width:'100%', padding:'5px 8px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.82rem' }} />
                              )}
                            </div>
                          ));
                        })()}
                      </div>
                      <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                        <button onClick={()=>setShowTxForm(false)} style={{ padding:'5px 14px', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:'0.82rem' }}>İptal</button>
                        <button onClick={saveTx} disabled={txSaving} style={{ padding:'5px 14px', border:'none', borderRadius:'var(--r-md)', background:'var(--accent-primary)', color:'#fff', cursor:'pointer', fontWeight:600, fontSize:'0.82rem' }}>{txSaving?'Kaydediliyor...':'Kaydet'}</button>
                      </div>
                    </div>
                  )}
                  <TransactionTable types={EXP_TX_TYPES} transactions={transactions} loading={txLoading} onDelete={deleteTx} currency={selected?.currency_code} />
                  </>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── Ekstre görünümü ─────────────────────────────────────────────────
function StatementView({ selected, statement, loading, period, onChangePeriod }) {
  if (!selected) return null;
  if (!selected.statement_day) {
    return (
      <div style={{ padding:20, textAlign:'center', color:'var(--text-secondary)', fontSize:'0.85rem',
        background:'rgba(245,158,11,0.08)', border:'1px solid rgba(245,158,11,0.25)', borderRadius:8 }}>
        ⚠ Bu kart için <strong>Hesap Kesim Günü</strong> tanımlanmamış. Düzenle butonuna tıklayıp kart bilgilerine kesim ve son ödeme gününü girin.
      </div>
    );
  }
  if (loading) return <div style={{ padding:20, textAlign:'center', color:'var(--text-secondary)' }}>Yükleniyor...</div>;

  // Önceki/sonraki ay navigasyonu
  const navMonth = (delta) => {
    const [y, m] = period.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    onChangePeriod(d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0'));
  };

  return (
    <div>
      {/* Dönem navigasyonu */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:14, marginBottom:14 }}>
        <button onClick={() => navMonth(-1)}
          style={{ background:'var(--bg-secondary)', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', padding:'4px 12px', cursor:'pointer', fontSize:'0.85rem' }}>
          ← Önceki Ay
        </button>
        <input type="month" value={period} onChange={e => onChangePeriod(e.target.value)}
          style={{ padding:'6px 10px', border:'1px solid var(--border-input)', borderRadius:'var(--r-md)', background:'var(--bg-input)', color:'var(--text-primary)', fontSize:'0.88rem', fontWeight:600 }} />
        <button onClick={() => navMonth(1)}
          style={{ background:'var(--bg-secondary)', border:'1px solid var(--border-secondary)', borderRadius:'var(--r-md)', padding:'4px 12px', cursor:'pointer', fontSize:'0.85rem' }}>
          Sonraki Ay →
        </button>
      </div>

      {!statement ? (
        <div style={{ padding:20, textAlign:'center', color:'var(--text-secondary)' }}>Veri yok</div>
      ) : (
        <>
          {/* Özet kartları */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))', gap:10, marginBottom:14 }}>
            <SummaryBox label="Dönem"  value={`${fmtDate(statement.period_start)} - ${fmtDate(statement.period_end)}`} small />
            {statement.due_date && <SummaryBox label="Son Ödeme" value={fmtDate(statement.due_date)} color="var(--warning)" small />}
            <SummaryBox label="Harcamalar" value={fmt(statement.total_expense, statement.currency_code)} color="var(--danger)" />
            {statement.total_refund > 0 && <SummaryBox label="İadeler" value={fmt(statement.total_refund, statement.currency_code)} color="var(--info)" />}
            {statement.total_payment > 0 && <SummaryBox label="Ödemeler" value={fmt(statement.total_payment, statement.currency_code)} color="var(--success)" />}
            {statement.monthly_fee > 0 && <SummaryBox label="Aidat" value={fmt(statement.monthly_fee, statement.currency_code)} color="var(--text-secondary)" small />}
            <SummaryBox label="DÖNEM TOPLAMI" value={fmt(statement.period_total, statement.currency_code)} color="var(--danger)" bold />
          </div>

          {/* Hareketler tablosu */}
          {statement.transactions.length === 0 ? (
            <div style={{ padding:20, textAlign:'center', color:'var(--text-tertiary)', fontSize:'0.85rem' }}>
              Bu dönem içinde hareket yok
            </div>
          ) : (
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.83rem' }}>
                <thead>
                  <tr style={{ borderBottom:'1px solid var(--border-secondary)', color:'var(--text-tertiary)', fontSize:'0.74rem' }}>
                    <th style={{ textAlign:'left', padding:'6px 4px', width:90 }}>Tarih</th>
                    <th style={{ textAlign:'left', padding:'6px 4px', width:80 }}>Tip</th>
                    <th style={{ textAlign:'left', padding:'6px 4px' }}>Açıklama</th>
                    <th style={{ textAlign:'left', padding:'6px 4px', width:130 }}>Kategori</th>
                    <th style={{ textAlign:'right', padding:'6px 4px', width:110 }}>Tutar</th>
                  </tr>
                </thead>
                <tbody>
                  {statement.transactions.map(t => {
                    const cfg = EXP_TX_TYPES.find(x => x.value === t.transaction_type);
                    return (
                      <tr key={t.id} style={{ borderBottom:'1px solid var(--border-secondary)' }}>
                        <td style={{ padding:'6px 4px', fontFamily:'monospace' }}>{fmtDate(t.transaction_date)}</td>
                        <td style={{ padding:'6px 4px' }}>
                          <span style={{ color: cfg?.color, fontWeight:600, fontSize:'0.78rem' }}>{cfg?.label || t.transaction_type}</span>
                        </td>
                        <td style={{ padding:'6px 4px' }}>{t.description}</td>
                        <td style={{ padding:'6px 4px', color:'var(--text-tertiary)', fontSize:'0.78rem' }}>{t.expense_category || '-'}</td>
                        <td style={{ padding:'6px 4px', textAlign:'right', fontFamily:'monospace', fontWeight:600,
                          color: cfg?.sign === -1 ? 'var(--danger)' : 'var(--success)' }}>
                          {cfg?.sign === -1 ? '-' : '+'}{fmt(t.amount, statement.currency_code)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function SummaryBox({ label, value, color, bold, small }) {
  return (
    <div style={{
      background:'var(--bg-secondary)', borderRadius:'var(--r-md)',
      padding:'10px 14px', border:'1px solid var(--border-secondary)',
    }}>
      <div style={{ fontSize:'0.68rem', color:'var(--text-tertiary)', marginBottom:3, textTransform:'uppercase', letterSpacing:'0.04em' }}>{label}</div>
      <div style={{ fontWeight: bold ? 800 : 700, fontSize: small ? '0.75rem' : '0.9rem', color: color || 'var(--text-primary)', fontFamily: small ? 'inherit' : 'monospace' }}>{value}</div>
    </div>
  );
}
